import React from "react";
import Button from "../../ui/Button/Button";
import styles from "./ErrorComponent.module.scss";
import { useNavigate } from "react-router-dom";

export const ErrorComponent = ({ title, text, buttonTitle, path }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(path);
  };
  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{title}</div>
        <div className={styles.text}>{text}</div>
      </div>
      <Button
        className={styles.button}
        title={buttonTitle}
        onClick={handleNavigate}
      />
    </div>
  );
};
